// extracted by mini-css-extract-plugin
export default {"UserPrivileges":"UserPrivileges_UserPrivileges__7L4+8","lists":"UserPrivileges_lists__qWAub"};